/**
 * Kitchvo footer — accessible mobile accordion for link columns.
 */
(function () {
  const MOBILE_QUERY = window.matchMedia('(max-width: 989px)');

  class KitchvoFooterAccordion {
    constructor() {
      this.blocks = [];
      this.onMediaChange = this.onMediaChange.bind(this);
    }

    init() {
      const footer = document.querySelector('.kitchvo-footer__main');
      if (!footer) return;

      this.blocks = Array.from(
        footer.querySelectorAll('.kitchvo-footer__column--accordion')
      ).map((block) => {
        const heading = block.querySelector('.kitchvo-footer__column-heading');
        if (!heading) return null;

        const toggle = () => {
          if (!MOBILE_QUERY.matches) return;
          const isOpen = block.classList.toggle('is-open');
          heading.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        };

        heading.setAttribute('role', 'button');
        heading.setAttribute('tabindex', '0');
        heading.setAttribute('aria-expanded', 'false');

        heading.addEventListener('click', toggle);
        heading.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        });

        return block;
      }).filter(Boolean);

      MOBILE_QUERY.addEventListener('change', this.onMediaChange);
      this.onMediaChange();
    }

    onMediaChange() {
      const isMobile = MOBILE_QUERY.matches;

      this.blocks.forEach((block) => {
        const heading = block.querySelector('.kitchvo-footer__column-heading');
        if (!heading) return;

        if (isMobile) {
          block.classList.remove('is-open');
          heading.setAttribute('aria-expanded', 'false');
          heading.setAttribute('role', 'button');
          heading.setAttribute('tabindex', '0');
        } else {
          block.classList.add('is-open');
          heading.removeAttribute('role');
          heading.removeAttribute('tabindex');
          heading.removeAttribute('aria-expanded');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new KitchvoFooterAccordion().init();
  });
})();
